import logger from "../utils/logger";
const parseErrorMessage = async response => {
  let message = `Request failed: ${response.status}`;
  try {
    const data = await response.json();
    const detail = data.detail ?? data;
    message = typeof detail === 'string' ? detail : JSON.stringify(detail);
  } catch (err) {
    const text = await response.text();
    if (text) message = text;
  }
  return message;
};
export const handleProfileSave = async ({
  payload,
  user,
  request,
  setProfileBusy,
  setStatus,
  setUser,
  showStatus,
  loadProfileSummary,
  loadProfileStats
}) => {
  if (!user) return;
  setProfileBusy(true);
  setStatus(null);
  try {
    const updated = await request(`/api/v1/users/${user.id}`, {
      method: 'PATCH',
      body: JSON.stringify(payload)
    });
    setUser(updated);
    showStatus('success', 'Профиль обновлён.');
    loadProfileSummary().catch(error => logger.error(error));
    loadProfileStats().catch(error => logger.error(error));
  } catch (error) {
    logger.error(error);
    showStatus('error', error.message || 'Не удалось обновить профиль.');
    throw error;
  } finally {
    setProfileBusy(false);
  }
};
export const handleAvatarUpload = async ({
  file,
  user,
  apiBaseUrl,
  authHeader,
  setAvatarBusy,
  setUser,
  showStatus
}) => {
  if (!user) return;
  setAvatarBusy(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${apiBaseUrl}/api/v1/users/${user.id}/avatar`, {
      method: 'POST',
      headers: {
        ...authHeader
      },
      body: formData
    });
    if (!response.ok) {
      throw new Error(await parseErrorMessage(response));
    }
    const updated = await response.json();
    setUser(updated);
    showStatus('success', 'Аватар обновлён.');
  } catch (error) {
    logger.error(error);
    showStatus('error', error.message || 'Не удалось загрузить аватар.');
    throw error;
  } finally {
    setAvatarBusy(false);
  }
};
export const handleCertificatesUpload = async ({
  files,
  user,
  apiBaseUrl,
  authHeader,
  setCertificatesBusy,
  setUser,
  showStatus
}) => {
  if (!user) return;
  if (!files?.length) return;
  setCertificatesBusy(true);
  try {
    const formData = new FormData();
    files.forEach(file => {
      formData.append('files', file);
    });
    const response = await fetch(`${apiBaseUrl}/api/v1/users/${user.id}/certificates`, {
      method: 'POST',
      headers: {
        ...authHeader
      },
      body: formData
    });
    if (!response.ok) {
      throw new Error(await parseErrorMessage(response));
    }
    const updated = await response.json();
    setUser(updated);
    showStatus('success', 'Сертификаты загружены.');
  } catch (error) {
    logger.error(error);
    showStatus('error', error.message || 'Не удалось загрузить сертификаты.');
    throw error;
  } finally {
    setCertificatesBusy(false);
  }
};
export const handleTelegramLink = async ({
  user,
  request,
  setTelegramBusy,
  showStatus
}) => {
  if (!user) return;
  setTelegramBusy(true);
  try {
    const data = await request(`/api/v1/users/${user.id}/telegram/link`, {
      method: 'POST'
    });
    if (data?.url) {
      window.open(data.url, '_blank', 'noopener,noreferrer');
    }
    showStatus('success', 'Ссылка для Telegram создана.');
  } catch (error) {
    logger.error(error);
    showStatus('error', 'Не удалось создать ссылку для Telegram.');
  } finally {
    setTelegramBusy(false);
  }
};
export const loadProfileStats = async (request, userId, setProfileStats, setProfileStatsBusy) => {
  if (!userId) return;
  setProfileStatsBusy(true);
  try {
    const data = await request(`/api/v1/users/${userId}/stats`, {});
    setProfileStats(data);
  } catch (error) {
    logger.error(error);
  } finally {
    setProfileStatsBusy(false);
  }
};
